"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStylesFromSettings = void 0;
// eslint-disable-next-line import/prefer-default-export
var getStylesFromSettings = function (settings, prefix) {
    if (prefix === void 0) { prefix = 'style.'; }
    return Object.keys(settings || {}).reduce(function (prev, curr) {
        var _a;
        return (curr.startsWith(prefix) ? __assign(__assign({}, prev), (_a = {}, _a[curr.substring(prefix.length)] = settings[curr], _a)) : prev);
    }, {});
};
exports.getStylesFromSettings = getStylesFromSettings;
